import { render } from "./savings-for-employers.vue?vue&type=template&id=04e42824&scoped=true&ts=true"
import script from "./savings-for-employers.vue?vue&type=script&lang=ts"
export * from "./savings-for-employers.vue?vue&type=script&lang=ts"

import "./savings-for-employers.vue?vue&type=style&index=0&id=04e42824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e42824"]])

export default __exports__